import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { confirmAlert } from 'react-confirm-alert';
import Loader from 'features/Loader/Loader';
import CustomDialog from 'shared/components/custom-dialog/CustomDialog';
import { workoutsLogSchema } from 'utils/validators/workoutsLog.js';
import {
  getWorkout,
  createWorkoutLog
} from 'features/clientProfile/components/workoutTab/ducks/clientProfileWorkoutActions';
import WorkoutLogForm from 'features/clientProfile/components/workoutTab/WorkoutLog/WorkoutLogForm';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import WorkoutLogSeriesList from './WorkoutLogSeriesList';
import { getClient } from '../../../ducks/clientProfileActions';

class WorkoutLog extends React.Component {
  constructor(props) {
    super(props);
    this.clientId = props.match.params.client_id;
    this.workoutId = props.match.params.workout_id;

    this.state = {
      cancel: false,
      seriesIndex: null,
      formMood: false,
      loggedSeriesIndices: []
    };
  }

  componentDidMount = () => {
    let { history } = this.props;
    this.props.getClient(this.clientId, history);
    this.props.getWorkout(this.workoutId, history);
  };

  handlelogcancelation = event => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <CustomDialog
            title="Are you sure you want to cancel?"
            text="All inputs in your workout will be lost"
            cancelText="No"
            confirmText="Yes"
            onClose={onClose}
            handleConfirming={() => {
              this.setState({ cancel: true });
            }}
          />
        );
      }
    });
  };

  backToLogSummery = seriesIndex => {
    let { loggedSeriesIndices } = this.state;
    this.setState({
      loggedSeriesIndices:
        typeof seriesIndex === 'number'
          ? [...loggedSeriesIndices, seriesIndex]
          : [...loggedSeriesIndices],
      formMood: false
    });
  };

  showSeriesForm = (seriesIndex, values, setFieldValue) => {
    this.setState({
      seriesIndex: seriesIndex,
      formMood: true
    });
  };

  render() {
    let {
      client,
      workout,
      loading,
      createWorkoutLog,
      logIsSubmitted
    } = this.props;
    let { formMood, cancel, seriesIndex, loggedSeriesIndices } = this.state;
    let name = client ? `${client.first_name} ${client.last_name}` : '';
    let hasSeries = workout && (workout.series || []).length;

    if (cancel || logIsSubmitted) {
      return <Redirect to={`/clients/${this.clientId}?tab=workout`} />;
    }

    if (loading) {
      return <Loader />;
    }
    return (
      <Formik
        initialValues={
          hasSeries && {
            series: workout.series.map(seriesElement => {
              return {
                id: seriesElement.id,
                name: seriesElement.name,
                is_custom_reps: seriesElement.is_custom_reps,
                reps: seriesElement.reps,
                method: seriesElement.method,
                setsNum: seriesElement.sets,
                exercises: seriesElement.exerciseCollection.map(exercise => {
                  return {
                    id: exercise.id,
                    name: exercise.exercise_name,
                    weight: exercise.weight,
                    tempo: exercise.tempo,
                    rest: exercise.rest,
                    rest_unit: exercise.rest_unit
                  };
                }),
                sets: [...Array(seriesElement.sets).keys()].map(value => {
                  let exercises = {};
                  seriesElement.exerciseCollection.forEach(exercise => {
                    exercises[exercise.id] = {};
                  });
                  return { ...exercises };
                })
              };
            }),
            currentSets: []
          }
        }
        onSubmit={values => {
          return createWorkoutLog(
            values,
            workout,
            this.state.loggedSeriesIndices,
            this.clientId
          );
        }}
        validationSchema={workoutsLogSchema}
      >
        {formik => (
          <Form>
            {formik.isSubmitting ? (
              <Loader />
            ) : formMood ? (
              <WorkoutLogForm
                clientId={this.clientId}
                clientName={name}
                workoutName={workout.name}
                values={formik.values}
                seriesIndex={seriesIndex}
                setFieldValue={formik.setFieldValue}
                backToLogSummery={this.backToLogSummery}
                errors={formik.errors}
                setFieldTouched={formik.setFieldTouched}
                setErrors={formik.setErrors}
              />
            ) : (
              <div className="workout-details">
                <div className="container">
                  <Breadcrumb>
                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                    <Breadcrumb.Item href={`/clients/${this.clientId}`}>
                      {name}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                      {workout && workout.name}
                    </Breadcrumb.Item>
                  </Breadcrumb>

                  <div className="page-title">
                    <h4>
                      {workout && workout.name}
                      <span>
                        {workout && workout.level}{' '}
                        {workout && workout.phase && `Phase ${workout.phase}`}
                      </span>
                    </h4>
                    {!!hasSeries && (
                      <div className="title-action">
                        <div
                          className="cancel-link"
                          onClick={this.handlelogcancelation}
                        >
                          Cancel
                        </div>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={!loggedSeriesIndices.length}
                        >
                          Save
                        </button>
                      </div>
                    )}
                  </div>
                  {hasSeries ? (
                    <WorkoutLogSeriesList
                      values={formik.values}
                      showSeriesForm={this.showSeriesForm}
                    />
                  ) : (
                    <div className="workout-details">
                      <div className="container">
                        <div className="page-title">
                          <h1>This Workout has no Series!</h1>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    workout: state.clientProfileWorkoutReducer.workout,
    loading: state.clientProfileWorkoutReducer.loading,
    logIsSubmitted: state.clientProfileWorkoutReducer.logIsSubmitted
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getWorkout: (workoutId, history) =>
      dispatch(getWorkout(workoutId, history)),
    createWorkoutLog: (values, workout, loggedSeriesIndices, clientId) =>
      dispatch(createWorkoutLog(values, workout, loggedSeriesIndices, clientId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkoutLog);
